module.exports = __webpack_public_path__ + "res/img_top_center.e7e6f3816b577a1afe449264ec47ab1c.png";